<template>
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 841.89 718.13"
        style="enable-background: new 0 0 841.89 718.13"
        xml:space="preserve"
    >
        <path
            d="M354.32,377.65c0,0-1.9-79.96,64.81-85.88c0,0,48.34-6.38,64.44,27.95c16.48,35.17-27.58,69.08-54.53,39.94
	c0.72,0.07,1.46,0.13,2.2,0.13c10.57,0,19.13-8.56,19.13-19.12c0-10.56-8.56-18.85-19.13-19.12c-4.46-0.11-10.05,1.53-10.05,1.53
	c-9.03,3.12-21.25,12.47-21.87,29.77c-1.76,49.09,55.85,54.37,57.05,54.5c7.14,0.73,105.82,1.24,105.24-98.53
	c-0.61-104.77-106.53-104.94-106.53-104.94H280.3v310.41h267.03v-2.53C547.32,511.74,358.06,507.15,354.32,377.65"
        />
    </svg>
</template>
<script>
export default {
    name: "PierreCardinLogo",
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/V2/uspaV2/asset/PierreCardinLogo.vue